import { useAtom } from "jotai";
import { useEffect } from "react";

import {
  isEditingSimDetailsAtom,
  isSimDetailsSectionActiveAtom,
} from "@/utils/atoms";

/**
 * Owns the "editing SIM details" flag. It resets the flag whenever the user
 * navigates to a different SIM — leftover edit state from a previous SIM must
 * not leak into the newly opened one — and returns the current value for the
 * caller to feed into the tab-disable rules.
 */
export const useResetSimEditState = (simId: string): boolean => {
  const [isEditingSimDetails, setIsEditingSimDetails] = useAtom(
    isEditingSimDetailsAtom,
  );
  const setSimDetailsSectionActive = useAtom(isSimDetailsSectionActiveAtom)[1];

  // Reset edit state when navigating to a different SIM.
  useEffect(() => {
    setIsEditingSimDetails(false);
    setSimDetailsSectionActive(false);
  }, [simId, setIsEditingSimDetails, setSimDetailsSectionActive]);

  return isEditingSimDetails;
};
